import angular from "angular";
//import scss from 'webmodals/webmodals.scss'
import modals from "webmodals/modals";
import Modal from "webmodals/modal";
import lightbox from "webmodals/lightbox";
// import fullscreen from "webmodals/fullscreen";
import tray from "webmodals/tray";
import ngAside from "angular-aside";
import "angular-aside/dist/css/angular-aside.css";
import "webmodals/ng-aside.scss";
import ShowModalDirective from "webmodals/show-modal";
import angularbox from "webmodals/angularbox";
//import uiBootstrap from 'angular-ui-bootstrap';
import "webutils/app";

export const app = angular
  .module("webmodals", ["ui.bootstrap", ngAside, "webutils"])
  .directive("angularbox", angularbox.AngularBoxDirective)
  .directive("angularbox", angularbox.AngularBoxSmallDirective)
  .value("modals", modals)
  .component("modal", Modal)
  .component("lightbox", lightbox)
  .component("tray", tray)
  .directive("showModal", ShowModalDirective);

// fullscreen(app);

export default app.name;
